'use client';
import { useEffect } from 'react';

export const Freespee: React.FC = () => {
  const freespeeId = process.env.NEXT_PUBLIC_FREESPEE_ID_WAYKE;

  useEffect(() => {
    if (!freespeeId) return;

    // Add delay before initializing Freespee to ensure cookies are fully cleaned up
    const timer = setTimeout(() => {
      window.__fs_conf = window.__fs_conf || [];
      window.__fs_conf.push(['setAdv', { id: freespeeId }]);

      // Load Freespee script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://analytics.freespee.com/js/external/fs.min.js';
      document.head.appendChild(script);
    }, 20);

    return () => {
      clearTimeout(timer);
    };
  }, [freespeeId]);

  if (!freespeeId) return null;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
            // Clean up _ga cookies with "deleted" value immediately, before anything else loads
            (function() {
              var cookies = document.cookie.split(';');
              var hostname = window.location.hostname;

              // Extract parent domain (e.g., "test.wayke.se" -> "wayke.se")
              var hostParts = hostname.split('.');
              var parentDomain = hostParts.length > 2 ? hostParts.slice(-2).join('.') : hostname;

              for (var i = 0; i < cookies.length; i++) {
                var cookieParts = cookies[i].trim().split('=');
                var name = cookieParts[0];
                var value = cookieParts[1];
                if (name && name.indexOf('_ga') === 0 && value === 'deleted') {
                  // Try multiple domain/path combinations to ensure deletion
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + hostname + ';';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.' + hostname + ';';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + parentDomain + ';';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.' + parentDomain + ';';
                }
              }
            })();
          `,
      }}
    />
  );
};
